import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getInformationBannerWidgetStyles = isSingleCarousel => {
  var spacing = tokens.spacing;
  return StyleSheet.create({
    container: {
      width: '100%',
      minHeight: 106,
      overflow: 'hidden'
    },
    image: {
      width: '100%',
      minHeight: 106,
      position: 'relative'
    },
    gradientOverlay: Object.assign({}, StyleSheet.absoluteFillObject),
    title: {
      position: 'absolute',
      paddingHorizontal: spacing.SPACING_16,
      bottom: isSingleCarousel ? spacing.SPACING_16 : spacing.SPACING_32
    }
  });
};